@import "../config/_helpers";

.callout-banner {
	// background: var(--secondary-color);
	background: #fef1e6;
	// color: white;
	text-align: center;
	margin-bottom: 20px;
	position: sticky;
	top: var(--main-header-height);
	z-index: 4;
	overflow: hidden;
	max-height: 200px;
	transition: 0.4s ease-in-out max-height;

	@include at-breakpoint(0, $l) {
		display: none;
	}

	a:hover {
		text-decoration: underline;
	}

	&.valentines-callout {
		background: #fef1e6;
		color: black;
		font-weight: bold;
	}

	&.mothers-day-callout {
		background: #fff1e6;
		font-weight: bold;
		color: black;
	}

	&.christmas-callout {
		background: darken(#fd6380, 28%);
		font-weight: bold;
	}

	& > a {
		padding: 10px 15px;
		display: block;
	}

	&.hidden {
		max-height: 0;
	}
}
